import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetLines } from '@/hooks/useGetLines';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function LineFormItem() {
	const form = useFormInstance();
	const organization_id: string = useWatch(['general_information', 'organization_id']);
	const company_id: string = useWatch(['general_information', 'company_id']);
	const sector_id: string = useWatch(['general_information', 'sector_id']);

	const lines = useGetLines({
		organization_id,
		company_id,
		sector_id
	});

	function handleOnChange(): void {
		form.setFieldValue(['general_information', 'workstation_id'], undefined);
	}

	const isDisabled: boolean = !organization_id || !company_id || !sector_id;

	return (
		<S.CustomFormItem name={['general_information', 'line_id']} label={I18n.get('Line')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				options={lines.data}
				disabled={isDisabled}
				onChange={handleOnChange}
				loading={lines.isFetching}
				placeholder={I18n.get('Line')}
			/>
		</S.CustomFormItem>
	);
}
